import whenDomReady from 'when-dom-ready';
const IS_ACTIVE = 'is-active';
function initialise() {
    const tabSections = document.querySelectorAll('.js-tabbed-feature-section');
    if (!tabSections) {
        return;
    }
    tabSections.forEach((section) => {
        const tabTitles = section.querySelectorAll('.js-tabbed-feature-title');
        tabTitles.forEach((title) => {
            title.addEventListener('click', () => handleClick(title, Array.from(tabTitles)));
        });
        // Show first item on desktop only.
        if (window.matchMedia('(min-width: 1024px)').matches) {
            tabTitles[0].classList.add(IS_ACTIVE);
        }
    });
}
function handleClick(title, titles) {
    // Check if title is already active.
    if (title.classList.contains(IS_ACTIVE)) {
        return;
    }
    // Otherwise collapse others and expand this.
    titles.forEach((t) => t.classList.remove(IS_ACTIVE));
    title.classList.add(IS_ACTIVE);
}
whenDomReady().then(initialise);
